import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-custom-spinner',
  templateUrl: './custom-spinner.component.html',
  styleUrl: './custom-spinner.component.scss'
})
export class CustomSpinnerComponent {
  @Input() size: number = 40;
  @Input() strokeWidth: number = 5;
}
